import api from './api';

const impactStatisticsService = {
  async get() {
    try {
      const response = await api.get('/impact-statistics');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas de impacto:', error);
      throw error;
    }
  },

  async update(data) {
    try {
      const response = await api.put('/impact-statistics', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar estatísticas de impacto:', error);
      throw error;
    }
  }
};

export default impactStatisticsService;
